import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { featureMaster } from 'src/app/Models/BasicForms/featureMaster';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-feature-drawer',
  templateUrl: './feature-drawer.component.html',
  styleUrls: ['./feature-drawer.component.css'],
  providers: [DatePipe]
})

export class FeatureDrawerComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: featureMaster;
  @Input() ShowLinkOrNot: boolean;
  @ViewChild('endDatePicker') endDatePicker: NzDatePickerComponent;

  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.loadAllModules();
  }

  moduleList = [];
  loadAllModules() {
    this._apiService.getAllModules(0, 0, 'ID', 'desc', '').subscribe(moduleData => {
      this.moduleList = moduleData['data'];

    }, err => {

    });
  }

  isSpinning = false;
  logtext: string = "";
  save(addNew: boolean): void {
    var isOk = true;

    if (this.data.MODULE_ID == undefined) {
      isOk = false;
      this.notificationService.error("Please Select Valid Module", "");
    }

    if (this.data.NAME != undefined) {
      if (this.data.NAME.trim() == '') {
        isOk = false;
        this.notificationService.error("Please Enter Valid Feature Name", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Feature Name", "");
    }

    if (this.data.STATUS != undefined) {
      if (this.data.STATUS.trim() == '') {
        isOk = false;
        this.notificationService.error("Please Select Valid Status", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Select Valid Status", "");
    }

    // if(this.data.DESCRIPTION != undefined) {
    //   if(this.data.DESCRIPTION.trim()== '') {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Valid Feature Description","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Valid Feature Description","");
    // }

    // if(this.data.START_DATE != undefined) {
    //   if(this.data.START_DATE== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Select Start Date","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Select Start Date","");
    // }

    // if(this.data.END_DATE != undefined) {
    //   if(this.data.END_DATE== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Select End Date","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Select End Date","");
    // }

    // if(this.data.ESTIMATED_MANDAYS != undefined) {
    //   if(this.data.ESTIMATED_MANDAYS== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Estimated Mandays","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Estimated Mandays","");
    // }

    // if(this.data.ESTIMATED_HOURS != undefined) {
    //   if(this.data.ESTIMATED_HOURS== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Estimated Hour(s)","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Estimated Hour(s)","");
    // }

    // if(this.data.ESTIMATED_MINUTES != undefined) {
    //   if(this.data.ESTIMATED_MINUTES== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Estimated Minute(s)","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Estimated Minute(s)","");
    // }

    // if(this.data.ESTIMATED_SECONDS != undefined) {
    //   if(this.data.ESTIMATED_SECONDS== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Estimated Second(s)","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Estimated Second(s)","");
    // }

    if (isOk) {
      this.isSpinning = true;
      if (this.data.START_DATE != null) {
        this.data.START_DATE = this.datePipe.transform(this.data.START_DATE, "yyyy-MM-dd");
      } else {
        this.data.START_DATE = null;
      }

      if (this.data.END_DATE != null) {
        this.data.END_DATE = this.datePipe.transform(this.data.END_DATE, "yyyy-MM-dd");
      } else {
        this.data.END_DATE = null;
      }

      this.data.ESTIMATED_HOURS = 0;
      this.data.ESTIMATED_MINUTES = 0;
      this.data.ESTIMATED_SECONDS = 0;

      if (!this.data.ID) {
        this._apiService.createFeature(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Feature Added Successfully", "");

            if (!addNew) {
              this.drawerClose();
              this.isSpinning = false;

              this.logtext = 'Save & Close - Feature Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Feature Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });

            } else {
              this.data = new featureMaster();

              this.logtext = 'Save & New - Feature Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Feature Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });
            }
            this.isSpinning = false;

          } else {
            this.notificationService.error("Failed to Add Feature", "");
            this.logtext = 'Save & Close - Feature Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Feature Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });

      } else {
        this._apiService.updateFeature(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Feature Updated Successfully", "");
            this.logtext = 'Update & Close - Feature Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Feature Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });

            this.isSpinning = false;
            this.drawerClose();

          } else {
            this.notificationService.error("Failed to Update Feature", "");
            this.logtext = 'Update & Close - Feature Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Feature Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });
      }
    }
  }

  close(featureMasterPage: NgForm) {
    this.drawerClose();
    this.resetDrawer(featureMasterPage);
  }

  handleStartOpenChange(open: boolean): void {
    if (!open) {
      this.endDatePicker.open();
      this.data.END_DATE = this.data.START_DATE;
    }
  }

  resetDrawer(clientMasterPage: NgForm) {
    this.data = new featureMaster();
    this.isSpinning = false;
    clientMasterPage.form.reset();
    this.ShowLinkOrNot = null;
  }
}
